import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{staticStyle:{"max-width":"300px"},attrs:{"dense":"","outlined":"","placeholder":"Search","hide-details":"","append-icon":"search"},on:{"input":_vm.searchList}})}
var staticRenderFns = []

export { render, staticRenderFns }